import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppStorage } from './appStorage.service';
import { ENDPOINTS } from '../constants/app-values';

@Injectable({
  providedIn: 'root'
})
export class ApiEstadisticasService {
  constructor(private httpClient: HttpClient, private appStorage: AppStorage) {}

  diezPeores(proceso, anno, mes) {
    const headers = new HttpHeaders({
      Authorization: this.appStorage.token,
      'Content-type': 'application/json'
    });

    const body: any = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: ''
    };

    if (mes) {
      body.mes = mes.numero;
    }

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/metrica/global/diespeores/`, body, {
        headers: headers
      })
      .toPromise();
  }

  cumplimiento(proceso, anno, mes) {
    const headers = new HttpHeaders({
      Authorization: this.appStorage.token,
      'Content-type': 'application/json'
    });

    const body: any = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: ''
    };

    if (mes) {
      body.mes = mes.numero;
    }

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/metrica/global/cumplimiento/`, body, {
        headers: headers
      })
      .toPromise();
  }

  atraso(proceso, anno, mes) {
    const headers = new HttpHeaders({
      Authorization: this.appStorage.token,
      'Content-type': 'application/json'
    });

    const body: any = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: ''
    };

    if (mes) {
      body.mes = mes.numero;
    }

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/metrica/global/atraso/`, body, {
        headers: headers
      })
      .toPromise();
  }

  metricaEmpresas(empresa, proceso, anno, mes) {
    const headers = new HttpHeaders({
      Authorization: this.appStorage.token,
      'Content-type': 'application/json'
    });

    const body: any = {
      idEmpresa: empresa.idEmpresa,
      idProceso: proceso.idProceso,
      anio: anno,
      mes: ''
    };

    if (mes) {
      body.mes = mes.numero;
    }

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/metrica/empresa/`, body, {
        headers: headers
      })
      .toPromise();
  }

  diezPeoresPublico(proceso, anno, mes) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const body: any = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: ''
    };

    if (mes) {
      body.mes = mes.numero;
    }

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/publico/metrica/global/diespeores/`, body, {
        headers: headers
      })
      .toPromise();
  }

  cumplimientoPublico(proceso, anno, mes) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const body: any = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: ''
    };

    if (mes) {
      body.mes = mes.numero;
    }

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/publico/metrica/global/cumplimiento/`, body, {
        headers: headers
      })
      .toPromise();
  }

  atrasoPublico(proceso, anno, mes) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const body: any = {
      idProceso: proceso.idProceso,
      anio: anno,
      mes: ''
    };

    if (mes) {
      body.mes = mes.numero;
    }

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/publico/metrica/global/atraso/`, body, {
        headers: headers
      })
      .toPromise();
  }

  metricaEmpresasPublico(empresa, proceso, anno, mes) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const body: any = {
      idEmpresa: empresa.idEmpresa,
      idProceso: proceso.idProceso,
      anio: anno,
      mes: ''
    };

    if (mes) {
      body.mes = mes.numero;
    }

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/publico/metrica/empresa/`, body, {
        headers: headers
      })
      .toPromise();
  }
}
